import React from "react";
import { Button } from "../ui/button";
import { ArrowLeftIcon, ArrowRightIcon, PlayIcon, PauseIcon } from "lucide-react";
import CarouselDotButton from "./CarouselDotButton";

type CarouselNavigationProps = {
  api: any;
  scrollSnaps: number[];
  selectedIndex: number;
  isPlaying: boolean;
  togglePlayPause: () => void;
  onUserInteraction: () => void;
};

const CarouselNavigation = ({
  api,
  scrollSnaps,
  selectedIndex,
  isPlaying,
  togglePlayPause,
  onUserInteraction,
}: CarouselNavigationProps) => {
  return (
    <div className="relative mx-auto mt-12 flex max-w-2xl items-center justify-center space-x-4 p-4">
      <Button
        variant="ghost"
        className="text-black"
        onClick={() => {
          api?.scrollPrev();
          onUserInteraction();
        }}
      >
        <ArrowLeftIcon size={20} />
      </Button>
      <div className="flex flex-col items-center space-y-2">
        <div className="embla__dots flex items-center space-x-2">
          {scrollSnaps.map((dot, index) => (
            <CarouselDotButton
              key={dot}
              index={index}
              selectedIndex={selectedIndex}
              onClick={() => {
                api?.scrollTo(index);
                onUserInteraction();
              }}
            />
          ))}
          <Button
            variant="ghost"
            className="text-black"
            onClick={() => {
              togglePlayPause();
              onUserInteraction();
            }}
          >
            {isPlaying ? (
              <PauseIcon fill="currentColor" size={20} className="text-black" />
            ) : (
              <PlayIcon fill="currentColor" size={20} className="text-black" />
            )}
          </Button>
        </div>
      </div>
      <Button
        variant="ghost"
        className="text-black"
        onClick={() => {
          api?.scrollNext();
          onUserInteraction();
        }}
      >
        <ArrowRightIcon size={20} />
      </Button>
    </div>
  );
};

export default CarouselNavigation;
